<template>
  <fieldset
    :class="classes"
    class="form__fieldset"
  >
    <legend v-if="hasLegend">{{ legend }}</legend>
    <slot />
  </fieldset>
</template>

<script>
import isBlank from 'is-blank'

export default {
  name: 'FormFieldSet',
  props: {
    legend: {
      type: String,
      default: () => null
    },
    shouldShowBorder: {
      type: Boolean,
      default: () => true
    }
  },
  computed: {
    classes () {
      return {
        'form__fieldset--no-border': !this.shouldShowBorder
      }
    },
    hasLegend () {
      return !isBlank(this.legend)
    }
  }
}
</script>

<style lang="sass">
@import '~styles/imports'

.form__fieldset
  border-top: 1px solid $color-grey-1
  padding-top: rem-calc(50)
  position: relative

  & + &
    margin-top: rem-calc(50)

.form__fieldset--no-border
  border-top: 0 none
  padding-top: 0

</style>



// WEBPACK FOOTER //
// src/components/forms/FormFieldSet.vue